import { AutogenModelDfmTrackingProviders, AutogenRowDfmTrackingProviders } from "./autogen/AutogenModelDfmTrackingProviders";

export class ModelDfmTrackingProviders extends AutogenModelDfmTrackingProviders<RowDfmTrackingProviders> {
	constructor() {
		super(RowDfmTrackingProviders);
	}
}

export class RowDfmTrackingProviders extends AutogenRowDfmTrackingProviders {
}